import { css } from '@emotion/react'
import { Heading, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { MChatRiscoEnum } from 'graphql/types.generated'
import { useMemo } from 'react'

import { MCHAT_RESULTADOS } from '../../model-mChatRf'
import { MChatEscalaLine } from './MChatEscalaLine'

interface MChatEscalaProps {
  pontuacao: number
  risco: MChatRiscoEnum
  isInsideModal: boolean
}

export function MChatEscala(props: MChatEscalaProps) {
  const { pontuacao, risco, isInsideModal } = props

  const theme = useTheme()
  const styles = useMemo(() => createStyles(theme, isInsideModal), [isInsideModal, theme])

  const ariaLabel = `O gráfico medidor exibe o resultado da avaliação. A escala vai de 0 a 20 pontos, dividido em três faixas: risco baixo de 0 a 2, risco médio de 3 a 7 e risco elevado de 8 a 20. O marcador está na posição ${pontuacao}, dentro da faixa de risco ${MCHAT_RESULTADOS[risco].shortTitle}.`

  return (
    <VFlow vSpacing={0.75} aria-label={ariaLabel}>
      <VFlow>
        <div css={styles.grid}>
          <Text css={[styles.header, styles.columnBaixo]}>
            Baixo<span>(0-2)</span>
          </Text>
          <Text css={[styles.header, styles.columnMedio]}>
            Médio<span>(3-7)</span>
          </Text>
          <Text css={[styles.header, styles.columnElevado]}>
            Elevado<span>(8-20)</span>
          </Text>
        </div>
        <div css={styles.grid}>
          <MChatEscalaLine line={MChatRiscoEnum.BAIXO} risco={risco} pontuacao={pontuacao} />
          <MChatEscalaLine line={MChatRiscoEnum.MEDIO} risco={risco} pontuacao={pontuacao} />
          <MChatEscalaLine line={MChatRiscoEnum.ELEVADO} risco={risco} pontuacao={pontuacao} />
        </div>
      </VFlow>
      <div css={styles.subtitles}>
        <Heading level={5} css={[styles.subtitle, styles.subtitleColumn1]}>
          0
        </Heading>
        <Heading level={5} css={[styles.subtitle, styles.subtitleColumn2, styles.fixCharacterPosition]}>
          2
        </Heading>
        <Heading level={5} css={[styles.subtitle, styles.subtitleColumn3, styles.fixCharacterPosition]}>
          7
        </Heading>
        <Heading level={5} css={[styles.subtitle, styles.subtitleColumn4]}>
          20
        </Heading>
      </div>
    </VFlow>
  )
}

const createStyles = (theme: Theme, isInsideModal: boolean) => ({
  grid: css`
    display: grid;
    grid-template-columns: repeat(20, 1fr);
    gap: 2px;
  `,
  header: css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    padding-top: 2px;
    padding-bottom: 2px;
    background: ${theme.pallete.gray.c90};
    color: ${theme.pallete.gray.c10};
    flex-wrap: wrap;
    ${isInsideModal && 'flex-direction: column; gap: 0rem;'}
    ${theme.breakpoints.down('lg')} {
      flex-direction: column;
      gap: 0rem;
    }
    span {
      color: ${theme.pallete.gray.c40};
    }
  `,
  columnBaixo: css`
    grid-column: span 2;
  `,
  columnMedio: css`
    grid-column: span 5;
  `,
  columnElevado: css`
    grid-column: span 13;
  `,
  subtitles: css`
    display: grid;
    grid-template-columns: repeat(20, 1fr);
    gap: 0;
  `,
  subtitleColumn1: css`
    grid-column: 1;
  `,
  subtitleColumn2: css`
    grid-column: 3;
  `,
  subtitleColumn3: css`
    grid-column: 8;
  `,
  subtitleColumn4: css`
    grid-column: 20;
    justify-self: end;
  `,
  subtitle: css`
    color: ${theme.pallete.gray.c40};
  `,
  fixCharacterPosition: css`
    margin-left: -0.25rem;
  `,
})
